const swiperReviewsLp2 = new Swiper('.swiper-reviews-lp2', {
    loop: true,
    slidesPerView: 1,
    //slidesPerGroup: 1,
    spaceBetween: 20,
    autoplay: {
        delay: 5000,
    },

    breakpoints: {
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: true,
            loop: true,
        }
    },

    pagination: {
        el: '.swiper-reviews-lp2 .hoox-swiper-dots2',
        clickable: true,
    },

    navigation: {
        nextEl: '.swiper-reviews-lp2 .hoox-swiper-next2',
        prevEl: '.swiper-reviews-lp2 .hoox-swiper-prev2',
    },
});